import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NumeroDocumentoIdentificacionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label
        text='NUM DOC'
        htmlFor='input-numeroDocumentoIdentificacion'
        md={4}
        alignRightAt='md'
      />
      <Col md={8}>
        <Field name='numeroDocumentoIdentificacion'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='input-numeroDocumentoIdentificacion'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoIdentificacionFormGroup)
